export const ShortsSliderSkeleton = () => {
  return (
    <div className="shorts-slider-wrapper padding-top padding-bottom bg-color">
      <div className="container placeholder-glow">
        
        {/* Header Skeleton */}
        <div className="d-flex justify-content-between align-items-center mb-4">
          <div className="placeholder col-2" style={{ height: '32px' }}></div>
          <div className="d-flex gap-2">
            <div className="placeholder" style={{ width: '45px', height: '40px', borderRadius: '5px' }}></div>
            <div className="placeholder" style={{ width: '45px', height: '40px', borderRadius: '5px' }}></div>
          </div>
        </div>

        {/* Slider Items Skeleton (Showing 4 cards to match desktop view) */}
        <div className="row flex-nowrap overflow-hidden">
          {[1, 2, 3, 4].map((item) => (
            <div key={item} className="col-12 col-sm-6 col-md-4 col-lg-3">
              <article className="post post--short bg-white rounded-0">
                
                {/* 9:16 Video Thumbnail Skeleton */}
                <figure className="post__media post__video m-0">
                  <div 
                    className="placeholder w-100 rounded-3" 
                    style={{ aspectRatio: '9/16', display: 'block' }}
                  ></div>
                </figure>

                {/* Mini Product Card Skeleton */}
                <div className="post__body p-0 mt-3">
                  <div className="mini-product-card d-flex gap-2 p-2 border rounded">
                    {/* Product Image Thumb */}
                    <div 
                      className="placeholder rounded" 
                      style={{ width: '60px', height: '60px', flexShrink: 0 }}
                    ></div>
                    
                    {/* Product Text Lines */}
                    <div className="w-100">
                      <div className="placeholder col-10 mb-2" style={{ height: '12px' }}></div>
                      <div className="placeholder col-6" style={{ height: '12px' }}></div>
                    </div>
                  </div>
                </div>

              </article>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};